import { GROUP_KEYS, FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_SALES_LEADER_INEXPERIENCED, ONBOARDING_SALES_FREE } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { HAS_USED_HUBSPOT } from '../constants/queryParamConstants';
import { CRM_SIGNUP, MARKETING_SIGNUP, SALES_SIGNUP, SERVICE_SIGNUP } from '../constants/signupConstants';
import { EXPERIENCE_HAS_USED_CRM_PARAM, EXPERIENCE_NONE_PARAM, FALSEY_SURVEY_VALUE, SALES_HUB_INTEREST, SALES_REP_ROLE, SURVEY_KEYS } from '../constants/surveyConstants';
import { createSalesGroupKey, createSalesOnboardingKey, getSalesInexperiencedGroupKey // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase
} from '../utils/onboardingKeyUtils'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { HubletUrl } from '../utils/urls';
const salesExperiencesChecks = [{
  redirectPath: (portalId, auth, survey) => {
    const salesOnboardingKey = createSalesOnboardingKey(survey[SURVEY_KEYS.JOB_ROLE], survey[SURVEY_KEYS.CRM_EXPERIENCE]);
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: salesOnboardingKey,
      groupKey: GROUP_KEYS.experiencedSalesIc
    };
  },
  checks: [{
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: HAS_USED_HUBSPOT,
      jobRole: SALES_REP_ROLE
    }
  }]
}, {
  redirectPath: (portalId, auth, survey) => {
    const salesOnboardingKey = createSalesOnboardingKey(survey[SURVEY_KEYS.JOB_ROLE], survey[SURVEY_KEYS.CRM_EXPERIENCE]);
    return {
      url: `${HubletUrl.getAppUrl()}/getting-set-up/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: salesOnboardingKey,
      groupKey: GROUP_KEYS.experiencedSalesLeader
    };
  },
  checks: [{
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: HAS_USED_HUBSPOT
    }
  }]
}, {
  redirectPath: (portalId, auth, survey) => {
    const salesOnboardingKey = createSalesOnboardingKey(survey[SURVEY_KEYS.JOB_ROLE], survey[SURVEY_KEYS.CRM_EXPERIENCE]);
    const salesInexperiencedGroupKey = getSalesInexperiencedGroupKey(survey[SURVEY_KEYS.JOB_ROLE]);
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: salesOnboardingKey,
      groupKey: salesInexperiencedGroupKey
    };
  },
  redirectParams: {
    variant: 'new-gs'
  },
  checks: [{
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM
    }
  }]
}, {
  redirectPath: (portalId, auth, survey) => {
    const jobRole = survey[SURVEY_KEYS.JOB_ROLE];
    const crmExperience = survey[SURVEY_KEYS.CRM_EXPERIENCE];
    const salesOnboardingKey = createSalesOnboardingKey(jobRole, crmExperience);
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: salesOnboardingKey,
      groupKey: createSalesGroupKey(jobRole, crmExperience)
    };
  },
  redirectParams: {
    variant: 'new-gs'
  },
  checks: [{
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_HAS_USED_CRM_PARAM
    }
  }]
}, // As Hub Interest is auto-filled for non-CRM Signup Types, this check goes
// last as it will prematurely match more specific checks above.
{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesView
    };
  },
  checks: [{
    signupType: CRM_SIGNUP,
    survey: {
      hubInterest: SALES_HUB_INTEREST
    }
  }]
}, {
  redirectPath: portalId => ({
    url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
    view: ONBOARDING_VIEWS.SALES,
    groupKey: GROUP_KEYS.INEXPERIENCED_SIMPLIFIED_SALES_LEADER,
    onboardingKey: ONBOARDING_SALES_LEADER_INEXPERIENCED
  }),
  redirectParams: {
    activeTab: ONBOARDING_VIEWS.SALES,
    enroll: 'true'
  },
  checks: [{
    signupType: [CRM_SIGNUP, SALES_SIGNUP, MARKETING_SIGNUP, SERVICE_SIGNUP],
    survey: {
      hubInterest: FALSEY_SURVEY_VALUE
    }
  }]
}];
export default salesExperiencesChecks;